import { FieldProps } from 'formik'

export const manuallyValidateFieldData = (fieldData: FieldProps) => {
    return (
        (!fieldData.meta.error && fieldData.meta.touched) ||
        (fieldData.meta.initialValue !== '' && !fieldData.meta.error)
    )
}

export const scrollToError = () => {
    const elementsWithErrors = document.querySelectorAll(`[class$="${'error'}"]`)
    const flexFieldErrors = document.getElementsByClassName('flex-field__flex-field--error') // should be removed once old flow is deprecated
    const top = elementsWithErrors[0] || flexFieldErrors[0]
    if (top) {
        top.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
}
